import startCase from "lodash/startCase";

export function compactStrings(
  parts: ReadonlyArray<string | null | undefined>,
): string[] {
  return parts
    .map((part) => part?.trim())
    .filter((part): part is string => !!part);
}

export function pluralize(count: number, noun: string): string {
  return `${count} ${noun}${count === 1 ? "" : "s"}`;
}

export function humanizeIdentifier(value: string): string {
  return value
    .trim()
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .replace(/[A-Za-z0-9]+(?:['’][A-Za-z0-9]+)?/g, (word) => startCase(word));
}
